import { render, staticRenderFns } from "./MouMoa.vue?vue&type=template&id=4dd0570f&scoped=true"
import script from "./MouMoa.vue?vue&type=script&lang=js"
export * from "./MouMoa.vue?vue&type=script&lang=js"
import style0 from "./MouMoa.vue?vue&type=style&index=0&id=4dd0570f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd0570f",
  null
  
)

export default component.exports